import React, { useContext, useEffect, useState } from 'react'
import { Form, Tooltip } from 'antd';

import { FormContext, Row, Button } from '@digital/ui';

import Upload, { UploadProps } from 'antd/lib/upload';

import { Visibility } from '../Visibility';
import UploadModalSubstituirAnexo from './uploadModalSubstituirAnexo';
import { UploadModalHistorico } from './uploadModalHistorico';

interface ISimpleUploadModalHistoricoProps {
    key?: string;
    onSubmit: (values: any) => Promise<boolean>;
    onSubimitSimpleUpload: (values: any) => Promise<boolean>;
    name?: string;
    required?: boolean;
    multiple?: boolean;
    validationSchema?: any;
    actions?: React.ReactNode[];

    fileName?: string;
    accept?: string;
    hasFile?: boolean;
    label?: string;
    hasLabel?: boolean;
    url?: string;
    disabled?: boolean;
    nameFormData?: string;
    type?: "link" | "ghost" | "default" | "primary" | "dashed" | "danger" | undefined;
    className?: string;
    idDoComponente: string;
    showUploadList?: boolean;
    span?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
    onBeforeUpload?: () => void;
    onDownload?: () => void;
    onDownloadVisible?: boolean;
    title?: string;
    onUploadVisible?: boolean;
    buttonUploadInFooter?: boolean;
}

export const SimpleUploadModalHistorico = ({
    key,
    onSubmit,
    onSubimitSimpleUpload,
    buttonUploadInFooter,
    fileName,
    hasFile = false,
    accept,
    label,
    hasLabel = true,
    url,
    disabled,
    nameFormData,
    type,
    className,
    idDoComponente,
    showUploadList = true,
    onDownload,
    onDownloadVisible = true,
    title,
    onUploadVisible = true,
}: ISimpleUploadModalHistoricoProps) => {
    const { formProps } = useContext(FormContext);

    const [arrFiles, setArrFile] = useState<any[]>();
    const [disabledItem, setDisabledItem] = useState<boolean>(false);

    const buttonLabel = label ? label : 'Adicionar arquivo';

    useEffect(() => {
        setDisabledItem(disabled != undefined && disabled == true ? true : false);
        fileName && setArrFile([{ uid: '1', name: fileName, url: url }]);
        let remove = !hasFile;
        if (remove) {
            setArrFile([]);
            formProps && formProps.setFieldValue(nameFormData ? nameFormData : 'formData', null);
        }
    }, [fileName, hasFile]);

    return (
        <Visibility visible={onDownloadVisible || onUploadVisible}>
            <Row align='middle' justify='center' type='flex'>
                <Visibility visible={onUploadVisible}>
                    <UploadModalHistorico
                        tooltip={title || 'Substituir arquivo'}
                        title={title || 'Substituir arquivo'}
                        buttonUploadText={buttonLabel}
                        hasUpload={true}
                        onSubmit={(values) => onSubmit && onSubmit(values)}
                        onUpload={(values) => onSubimitSimpleUpload && onSubimitSimpleUpload(values)}
                        buttonUploadInFooter={buttonUploadInFooter}
                    />
                </Visibility>

                <Visibility visible={onDownloadVisible}>
                    <Tooltip title="Download Arquivo">
                        <Button
                            id='mrn-button-download-SimpleUploadModalHistorico'
                            type={type ? type : 'link'}
                            icon="ui-download"
                            onClick={onDownload}
                        >
                        </Button>
                    </Tooltip>
                </Visibility>
            </Row>
        </Visibility>
    )
}
